import {FC} from 'react';

const DropdownActionDivider: FC = () => (
    <hr className="m-0 border-b border-grey-100" />
);

export default DropdownActionDivider;
